var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSocialX = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "var(--thc-icon-fill)",
  d: "M27.75 20.94 42.32 4h-3.45L26.22 18.7 16.12 4H4.45l15.28 22.24L4.46 44H7.9l13.36-15.53L31.94 44H43.6zm-4.73 5.5-1.55-2.22L9.15 6.6h5.3l9.95 14.22 1.55 2.21 12.92 18.49h-5.3z"
})));
export { SvgSocialX as ReactComponent };
export default new URL("/home/runner/work/motorway-seller-webapp/motorway-seller-webapp/node_modules/@motorway/mw-highway-code/src/assets/svgs/social-x.svg", import.meta.url).toString();